export default __webpack_public_path__ + "static/media/delete.a257feb1.svg";